import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling } from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import NameField from 'components/forms/new/formikFormFields/NameField';

const PlanInternationalDiscountField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.internationalDiscount && touched.internationalDiscount}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()} >
                <FormLabel sx={formLabelStyling(darkMode)}>
                    International Discount
                </FormLabel>
                <Field
                    as={NameField}
                    id="internationalDiscount"
                    name="internationalDiscount"
                    data-walkthroughid={walkthroughIds.plans.ufInternationalDiscountInput}
                    error={errors.internationalDiscount}
                    type="number"
                    step="any"
                />
                {isHovered && (
                    <FieldToolTip
                        label="Discount for international calls (%)"
                        ariaLabel="plan-international-discount-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlanInternationalDiscountField;
